import React from 'react';
import {BottomAppBar, TopAppBar, useLocation, useDivDimensions, appBarHeightVar, useCurrentUser} from '@eduvision/toolkit';
import { AppBar as MuiAppBar, Box } from '@mui/material';
import AccessPhraseUserAppBar from './AccessPhraseUserAppBar';

const AppBar = () => {
	const location = useLocation();
	const isPlayerRoute = location.pathname.includes('/player/');
	const currentUser = useCurrentUser();
	const ref = React.useRef<HTMLDivElement>(null);
	const [bottomAppBarEl, setBottomAppBarEl] = React.useState<HTMLDivElement | null>(null);
	const [isLogoLoaded, setIsLogoLoaded] = React.useState<boolean>(false);
	const deps = React.useMemo(() => [location.pathname, isLogoLoaded, currentUser?.isAccessPhraseUser, bottomAppBarEl], [location.pathname, isLogoLoaded, currentUser?.isAccessPhraseUser, bottomAppBarEl]);
	const { height } = useDivDimensions(ref, 'resize', deps);
	appBarHeightVar(height);


	const onBottomAppBarRef = React.useCallback((el: HTMLDivElement | null) => {
		if (el) {
			setBottomAppBarEl(el);
		}
	}, []);


	const onLogoLoad = React.useCallback((e) => {
		setIsLogoLoaded(true);
	},[]);

	return isPlayerRoute ? null : (
		<>
			<Box>
				<MuiAppBar position="fixed" ref={ref}>
					{currentUser?.isAccessPhraseUser ? <AccessPhraseUserAppBar /> : <TopAppBar onLogoLoad={onLogoLoad} />}
					{currentUser?.isAccessPhraseUser ? null : <BottomAppBar ref={onBottomAppBarRef} />}
				</MuiAppBar>
				<Box width="100%" height={height} />
			</Box>
		</>
	);
};

export default React.memo(AppBar);
